import React from "react";
import { cn } from "../lib/utils";

export function BpButton({ className, variant = "primary", ...props }) {
  const styles = {
    primary: "bg-brand text-onfill hover:bg-brand-hover",
    ghost: "bg-transparent text-ink hover:bg-surface-2",
    danger: "bg-pink text-onfill hover:bg-pink-hover",
    surface: "bg-inset text-ink border border-line hover:bg-inset-2",
  };
  return (
    <button
      className={cn(
        "rounded-xl px-4 py-2.5 font-semibold transition-colors disabled:opacity-40 disabled:pointer-events-none",
        styles[variant],
        className
      )}
      {...props}
    />
  );
}

export function BpCard({ className, ...props }) {
  return <div className={cn("bg-surface border border-line shadow-card rounded-2xl p-4", className)} {...props} />;
}

export function BpBadge({ className, tone = "orange", ...props }) {
  const tones = {
    orange: "bg-brand/15 text-brand-ink",
    pink: "bg-pink/15 text-pink-ink",
    gold: "bg-gold/15 text-gold-ink",
    cream: "bg-ink/10 text-ink/85",
  };
  return (
    <span
      className={cn("inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-semibold", tones[tone], className)}
      {...props}
    />
  );
}

export function BpInput({ className, ...props }) {
  return (
    <input
      className={cn(
        "w-full rounded-xl bg-inset border border-line px-3.5 py-2.5 text-ink placeholder:text-ink/50 focus:outline-none focus:border-brand",
        className
      )}
      {...props}
    />
  );
}

export function BpStepper({ value, onChange, step = 1, min = 0, testId }) {
  return (
    <div className="inline-flex items-center gap-2" data-testid={testId}>
      <button
        type="button"
        className="w-9 h-9 rounded-lg bg-inset border border-line text-brand-ink font-bold text-lg active:scale-95 transition-transform"
        onClick={() => onChange(Math.max(min, value - step))}
        data-testid={testId ? `${testId}-minus` : undefined}
      >
        −
      </button>
      <span className="min-w-[2.5rem] text-center font-semibold">{value}</span>
      <button
        type="button"
        className="w-9 h-9 rounded-lg bg-inset border border-line text-brand-ink font-bold text-lg active:scale-95 transition-transform"
        onClick={() => onChange(value + step)}
        data-testid={testId ? `${testId}-plus` : undefined}
      >
        +
      </button>
    </div>
  );
}

export function BpSkeleton({ className = "" }) {
  return <div className={`animate-pulse rounded-2xl bg-ink/10 ${className}`} data-testid="skeleton" />;
}

export function BpListSkeleton({ rows = 4, height = "h-20", className = "" }) {
  return (
    <div className={`space-y-2 ${className}`} data-testid="list-skeleton">
      {Array.from({ length: rows }).map((_, i) => <BpSkeleton key={i} className={height} />)}
    </div>
  );
}

export function BpWordmark({ className }) {
  return (
    <span className={cn("font-heading text-xl tracking-tight", className)}>
      <span>Bar</span>
      <span className="text-brand">Padi</span>
    </span>
  );
}
